import React from 'react'
import Typography from "@mui/material/Typography";
import SearchIcon from "@mui/icons-material/Search";
import CircularProgress from '@mui/material/CircularProgress';

import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../../HomePage/HomePage";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {useLocation, useNavigate} from "react-router";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import {useShallow} from "zustand/react/shallow";
import {useFetchHook} from "../../../hooks/useFetchHook";
import fetcher from "../../../fetcher";
import {useCRMStore} from "../../../stores/crmStore";
import {UploadCSVModal} from "./UploadCSVModal";
import {useModalsStore} from "../../../stores/modalsStore";

export const LeadsPageHeader = () => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const openModal = useModalsStore((state) => state.openModal)

    const [bulkUploadLeadsResponse, bulkUploadLeads] = useFetchHook(fetcher.bulkUploadLeads)

    const { search, setSearch, isLoading } = useCRMStore(
        useShallow((state) => ({
            search: state.search,
            setSearch: state.setSearch,
            isLoading: state.isLoading,
        }))
    )

    const navigate = useNavigate();
    const location = useLocation();

    return (
        <Stack
            id={"CRMHeader"}
            direction={isTabletOrMobile ? 'column' : 'row'}
            alignItems={isTabletOrMobile ? 'center' : 'end'}
            justifyContent={'space-between'}
        >
            <Stack
                direction={'row'}
                alignItems="center"
                justifyContent={'start'}
            >
                <Typography
                    sx={{
                        fontSize: '24px',
                        color: '#666'
                    }}
                    component="div"
                >
                    CRM
                </Typography>
                <Typography
                    sx={{
                        fontSize: '12px',
                        color: '#666',
                        marginLeft: '20px',
                    }}
                    component="span"
                >
                    {
                        isLoading ? "Saving..." : "Saved"
                    }
                </Typography>

            </Stack>

            <Stack
                // style={{ width: '100%' }}
                direction={isTabletOrMobile ? 'column' : 'row'}
                alignItems="center"
            >
                <Tabs
                    value={location.pathname}
                    onChange={(value, newValue) => {
                        navigate(`${newValue}`)
                    }}
                >
                    <Tab label="Leads" value={'/leads'} />
                    <Tab label="Clients" value={'/clients'}/>
                </Tabs>

                <div className={'CRM_header-search-container'}>
                    <input
                        className=""
                        type="text"
                        value={search}
                        placeholder={"Search Leads"}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    {
                        false ?
                            <CircularProgress size={20} sx={{ color: "#666666"}}/> :
                            <SearchIcon/>
                    }
                </div>
                <Button
                    className={'upload-csv-button'}
                    onClick={() => {
                        openModal({
                            element: UploadCSVModal,
                            id: "UploadCSVModal",
                            props: {
                                bulkUploadFunc: bulkUploadLeads
                            }
                        })
                    }}
                >
                    Upload CSV
                </Button>
            </Stack>

        </Stack>
    )
}